import axios from 'axios';
import { serverUrl, baseUrl, adminUrl, workflowUrl } from 'Config';
import AuthService from '../AuthService';

class AxiosService {
    constructor() {}

    headers() {
        if (AuthService.isLoggedIn()) {
            return {
                'Authorization': 'Bearer ' + AuthService.getToken(),
                'Pragma': 'no-cache'
            };
        }
        return ''
    }

    download(url, data) {
        return axios({
            method: 'POST',
            url: serverUrl + url,
            data: data,
            headers: this.headers(),
            responseType: 'blob'
        });
    }

    get(url, admin=false) {
        if (admin){
            return axios({
                method: 'GET',
                url: adminUrl + url,
                headers: this.headers()
            });
        }else{
            return axios({
                method: 'GET',
                url: serverUrl + url,
                headers: this.headers()
            });
        }        
    }
    
    workflowGet(url) {
        return axios({
            method: 'GET',
            url: workflowUrl + url,
            headers: this.headers()
        });
    }
    
    workflowPost(url, data) {
        return axios({
            method: 'POST',
            url: workflowUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    post(url, data) {
        return axios({
            method: 'POST',
            url: serverUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    put(url, data) {
        return axios({
            method: 'PUT',
            url: serverUrl + url,
            data: data,
            headers: this.headers()
        });
    }

    delete(url) {
        return axios({
            method: 'DELETE',
            url: serverUrl + url,
            headers: this.headers()
        });
    }

    publicPost(url, data) {

        return axios({
            method: 'POST',
            url: baseUrl + url,
            data: data
        });
    }
}

export default new AxiosService();


// WEBPACK FOOTER //
// ./src/services/REST/AxiosService.js